<style scoped>
    .g_pop{position:fixed;z-index:9999;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}
    .g_pop_loading{width:120px;background:rgba(0,0,0,.7);border-radius:5px}
    .g_pop_loading .pop_con{padding:20px 0}
    .g_pop_loading .pop_con .icon_loading{display:block;margin:10px auto;width:32px;height:32px;background-image:url(//vm.gtimg.cn/tencentvideo/vstyle/mobile/vip/style/app_v2/img/common/loading_64.gif?d=0106&max_age=31104000);background-position:center center;background-size:cover}
    .g_pop_loading .pop_con .txt{color:#fff;text-align:center}
</style>
<template>
    <div class="g_pop g_pop_loading " v-show="showState">
        <div class="pop_wrap">
            <div class="pop_con">
                <i class="icon_loading"></i>
                <p class="txt" v-if="msg">{{msg}}</p>
            </div>
        </div>
    </div>
</template>
<script>


    var loading = {
        msg: '',
        showState: false,
        showTimeout: 0
    }

    export default {
        data() {
            return loading
        },
        install(Vue){
            function show(msg='', timeout) {
                clearTimeout(loading.showTimeout);
                loading.msg = msg;
                loading.showState = true;
                if(typeof timeout == 'number'){
                    loading.showTimeout = setTimeout(() => {
                        loading.showState = false;
                    }, timeout)
                }
            }

            function hide() {
                loading.showState = false;
            }

            return Vue.prototype.loading = {show,hide}
        }
    }

</script>
